import React from "react";

const AlertAction = props => {
    const { title, message, cancel } = props;

    return(
        <div className={"actionDefined"}>
            <div className={"box"}>
                <p className={"title"}>{ title }</p>
                <p className={"message"}>{ message }</p>
                <p className={"close"} onClick={cancel}>Fermer</p>
            </div>
        </div>
    )
}

export default AlertAction;
